import * as React from 'react'
import {Flex} from '@freckle/student-materials/src/components/flex'
import Image from '@freckle/student-materials/src/components/img'
import Link from '@freckle/student-materials/src/components/link'
import {H1, Text} from '@freckle/student-materials/src/components/typography'
import {PATHS} from '@freckle/student-materials/src/helpers/paths'
import {SafeTrans, useSafeTranslation} from '@freckle/student-materials/src/helpers/translate'
import PiggyWaving from './piggy-waving.svg'
import {wrapperStyle, imageStyle, textStyle} from './error-page.module.scss'

export function ErrorPage({heading}: {heading?: string}): React.ReactElement {
  return (
    <div className={wrapperStyle}>
      <ErrorContent heading={heading} />
    </div>
  )
}

export function ErrorInline({heading}: {heading?: string}): React.ReactElement {
  return (
    <Flex flexDirection="column" justifyContent="center" alignItems="center">
      <ErrorContent heading={heading} />
    </Flex>
  )
}

function ErrorContent({heading}: {heading?: string}): React.ReactElement {
  const {t} = useSafeTranslation()
  return (
    <>
      <Image className={imageStyle} src={PiggyWaving} />
      <H1 addClass={textStyle}>{heading ?? t('ERROR_PAGE_HEADER')}</H1>
      <Text addClass={textStyle}>
        <SafeTrans
          components={{backLink: <Link href={PATHS.studentClientUrl} />}}
          i18nKey="ERROR_PAGE_INSTRUCTIONS"
        />
      </Text>
      <Text addClass={textStyle}>{t('ERROR_PAGE_STILL_NOT_WORKING')}</Text>
    </>
  )
}
